

















import { defineComponent } from '@nuxtjs/composition-api';
import { BaseImage, BaseLink } from '@shared/ui';

export default defineComponent({
  name: 'CategoryCardFlat',
  components: {
    BaseImage,
    BaseLink,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    imageSrc: {
      type: String,
      default: '',
    },
    imageAlt: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
  },
});
